import { render, staticRenderFns } from "./workRecordsWorkerPage.vue?vue&type=template&id=19373398&"
import script from "./workRecordsWorkerPage.vue?vue&type=script&lang=ts&"
export * from "./workRecordsWorkerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports